import { render, staticRenderFns } from "./PersonDocuments.vue?vue&type=template&id=91d7f146&scoped=true&"
import script from "./PersonDocuments.vue?vue&type=script&lang=ts&"
export * from "./PersonDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d7f146",
  null
  
)

export default component.exports